import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService  {

  private static API_ENDPOINT = environment.apiUrl;
  
  private static readonly hallsUrl =  ApiService.API_ENDPOINT + 'products/photozones';
  private static readonly dressesUrl =  ApiService.API_ENDPOINT + 'products/dresses';
  private static readonly paymentUrl = ApiService.API_ENDPOINT + 'payments/pay';
  private static readonly settingsUrl = ApiService.API_ENDPOINT + 'settings';
  private static readonly timesUrl = ApiService.API_ENDPOINT +'product/';
  private static readonly servicesUrl = ApiService.API_ENDPOINT + 'products/services';
  private static readonly portfolioUrl = ApiService.API_ENDPOINT + 'portfolio';
  private static readonly equipmentsUrl = ApiService.API_ENDPOINT + 'products/equipments';
  private static readonly portfolio = ApiService.API_ENDPOINT + 'portfolio';
  private static readonly checkLiqpayStatus = ApiService.API_ENDPOINT + 'payments/check-status/';
  private static readonly leadUrl = ApiService.API_ENDPOINT + 'lead';

  private static readonly pagesUrl = ApiService.API_ENDPOINT + 'pages';

  public _halls = [];
  public _dresses = [];
  public static_link = environment.staticUrl;
  public _portfolio = [];
  public _equipments = [];
  public _services = [];
  public _settings = [];
  public _pages = [];

  
  public dataResloved = false;
  get halls(): any[] {return this._halls;}
  set halls(value: any[]) {this._halls = value;}
  get dresses(): any[] {return this._dresses;}
  set dresses(value: any[]) {this._dresses = value;}
  get settings(): any[] {return this._settings;}
  set settings(value: any[]) {this._settings = value;}
  get portfolio(): any[] {return this._portfolio;}
  set portfolio(value: any[]) {this._portfolio = value;}
  get equipments(): any[] {return this._equipments;}
  set equipments(value: any[]) {this._equipments = value;}

  get pages(): any[] {return this._pages;}
  set pages(value: any[]) {this._pages = value;}

  get services(): any[] {return this._services;}
  set services(value: any[]) {this._services = value;}

  getHalls = (): Observable <any> => {
    return this.http.get(ApiService.hallsUrl);
  }

  getDresses = (): Observable <any> => {
    return this.http.get(ApiService.dressesUrl);
  }


  getSettings = ():Observable<any> => {
    return this.http.get(ApiService.settingsUrl);
  }

  getPortfolio = ():Observable<any> => {
    return this.http.get(ApiService.portfolioUrl);
  }

  getEquipments = ():Observable<any> => {
    return this.http.get(ApiService.equipmentsUrl);
  }

  getPages = (): Observable <any> => {
    return this.http.get(ApiService.pagesUrl);
  }


  getServices = ():Observable<any> => {
    return this.http.get(ApiService.servicesUrl);
  }

 
  getTimesUnavaliable = (selectedDate, selectedHall): Observable<any> => {
    return this.http.get(ApiService.timesUrl + selectedHall + '/interval/'+selectedDate);
  }

  checkPaymentStatus = (orderNumber): Observable<any> => {
    return this.http.get(ApiService.checkLiqpayStatus + orderNumber);
  }


  sendOrder = (order) => {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'text/plain',
      })
    };
    return this.http.post(ApiService.paymentUrl, (order), httpOptions ) ;
  }


  sendLead = (data) => {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'text/plain',
      })
    };
    return this.http.post(ApiService.leadUrl, (data), httpOptions ) ;
  }
  constructor(private http: HttpClient) {
   
    this.getHalls().subscribe(value => {
      for (let item of value['data']) {
        this._halls.push(item);
      }
    });

    this.getDresses().subscribe(value => {
      for (let item of value['data']) {
        this._dresses.push(item);
      }
    });

    this.getSettings().subscribe(value => {
      for (let item of value['data']) {
        this._settings.push(item);
      }
    });
    this.getPortfolio().subscribe(value => {
      for (let item of value['data']) {
        this._portfolio.push(item);
      }
    });

    this.getEquipments().subscribe(value => {
      for (let item of value['data']) {
        this._equipments.push(item);
      }
    });


    this.getServices().subscribe(value => {
      for (let item of value['data']) {
        this._services.push(item);
      }
    });


    this.dataResloved = true;
  }


}
